import { RoleType } from '@feature/security';

/** roles that can request a scoped report; anyone else only gets a 403 from the server */
export const canGenerateWosIsiReport = [
  RoleType.ADMIN,
  RoleType.UNIVERSITY_ADMIN,
  RoleType.FACULTY_ADMIN,
  RoleType.DEPARTMENT_ADMIN,
  RoleType.DISCIPLINE_ADMIN,
];
